import { Badge } from '@/components/ui/badge';
import { EntitySidecar } from '@/services/api/generated/partiesService';

interface SuggestionBadgeProps {
  approvalMetadata?: EntitySidecar | null;
  showLabel?: boolean;
  className?: string;
}

export const SuggestionBadge = ({
  approvalMetadata,
  showLabel = true,
  className = '',
}: SuggestionBadgeProps) => {
  if (!approvalMetadata) return null;

  const hasAcceptedFields =
    approvalMetadata.field_suggestions &&
    approvalMetadata.field_suggestions.length > 0;

  const statusConfig = {
    suggested: {
      color: 'bg-amber-50 text-amber-600 border-amber-200 hover:bg-amber-50',
      label: 'Suggested',
      indicator: '○',
    },
    partiallyApproved: {
      color: 'bg-green-50 text-green-600 border-green-200 hover:bg-green-50',
      label: 'Partially Approved',
      indicator: '◐',
    },
  };

  const config = hasAcceptedFields
    ? statusConfig.partiallyApproved
    : statusConfig.suggested;

  return (
    <Badge
      variant="outline"
      className={`${config.color} ${className} ${!showLabel ? 'min-w-5 justify-center px-1.5 py-0.5' : 'px-2 py-0.5'} text-xs font-medium`}
    >
      <span className={showLabel ? 'mr-1' : ''} aria-hidden="true">
        {config.indicator}
      </span>
      {showLabel && config.label}
    </Badge>
  );
};
